module.exports = __webpack_public_path__ + "static/img/4983_phase_function_Paper_PointsHejduk_Prediction.c924eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4983_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7i6I
// module chunks = 0